import { Flex } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import {
  DetailsViewProperties as Properties,
  DetailsViewPropertiesContent as PropertiesContent,
  DetailsViewPropertiesHeader as PropertiesHeader,
} from 'components/shared';

import { FormSharingOptions } from 'pages/Forms/common';
import { SharingSettings } from './SharingSettings';
import { useFormEditContext } from '../../context';

export const Sharing = () => {
  const { form } = useFormEditContext();
  const { t } = useTranslation('forms');
  return (
    <Properties>
      <PropertiesHeader title={t('editView.sidebar.sharing.title')} />
      <PropertiesContent>
        <Flex
          direction="column"
          sx={theme => ({ gap: theme.other.spacing(4) })}
        >
          <FormSharingOptions form={form} />
          <SharingSettings />
        </Flex>
      </PropertiesContent>
    </Properties>
  );
};
